export {
  default as ccApplePay,
  ReactComponent as CCApplePay,
} from '@assets/thirdParty/cc-apple-pay.svg'
